import { FieldType } from '@pmp/api';

export const BASE_RATES_VALUE_LIST_NAMES: FieldType[] = [FieldType.VARIABILITY_TYPE];
